import '../../config/common';

export { useOnboarding } from './hooks';
export { onboardingReducer } from './reducer';
